import UsuarioEnEspera from "./UsuarioEnEspera";
import { Card, Row, Col, Table } from "react-bootstrap";

const styles = {
  container: {
    backgroundColor: "var(--color-background-3)",
  },
  thNumero: {
    width: "10%",
  },
  thMotivo: {
    width: "20%",
  },
  thNombre: {
    width: "25%",
  },
  thRut: {
    width: "20%",
  },
  thAcciones: {
    width: "25%",
  },
  badge: {
    fontWeight: 400,
    backgroundColor: "var(--color-accent)",
    color: "var(--color-background)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  button: {
    marginLeft: "0.25rem",
    backgroundColor: "var(--color-green)",
    color: "var(--color-text)",
    border: "none",
    boxShadow: "none",
    outline: "none",
  },
  textoPersonas: {
    display: "inline-block",
  },
};

function ListaDeEspera({ cola, onAtender, actual }) {
  return (
    <Card className="h-100 w-100 p-4 shadow-sm border" style={styles.container}>
      <Row className="g-2 my-0">
        <Col xs={12}>
          <p className="h3 my-0">
            Lista de espera
            <span className="text-muted ms-1 h6">
              <i className="bi bi-person-circle mx-2"></i>
              {/* FIX: cambiar <p> por <span> */}
              <span style={styles.textoPersonas}>
                {cola.length === 0
                  ? "No hay personas en espera"
                  : cola.length === 1
                  ? "1 persona"
                  : `${cola.length} personas`}
              </span>
            </span>
          </p>
        </Col>

        <Col xs={12} className="my-0">
          <Table responsive>
            <thead>
              <tr>
                <th style={styles.thNumero}>Número</th>
                <th style={styles.thMotivo}>Motivo</th>
                <th style={styles.thNombre}>Nombre</th>
                <th style={styles.thRut}>RUT (Pasaporte)</th>
                <th style={styles.thAcciones}></th>
              </tr>
            </thead>
            <tbody>
              {cola.map((item) => (
                <UsuarioEnEspera
                  key={item.ticket_id}
                  usuario={item}
                  onAtender={onAtender}
                  styles={styles}
                  actual={actual}
                />
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Card>
  );
}

export default ListaDeEspera;
